
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { CreateDistributionCenterPriceInput } from '@/types/database/distribution-center-prices';
import { formatCurrency } from '@/lib/utils';

interface DistributionCenterPreviewTableProps {
  data: CreateDistributionCenterPriceInput[];
}

const DistributionCenterPreviewTable: React.FC<DistributionCenterPreviewTableProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No data to preview</p>
      </div>
    );
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Product Name</TableHead>
            <TableHead>Location</TableHead>
            <TableHead className="text-right">Price</TableHead>
            <TableHead>Remark</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <Badge variant="outline">
                  {new Date(item.date).toLocaleDateString()}
                </Badge>
              </TableCell>
              <TableCell className="font-medium">{item.product_name}</TableCell>
              <TableCell>{item.location}</TableCell>
              <TableCell className="text-right font-mono">
                {formatCurrency(item.price)}
              </TableCell>
              <TableCell className="max-w-xs">
                {item.product_remark && (
                  <span className="text-sm text-gray-600 line-clamp-2">
                    {item.product_remark}
                  </span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default DistributionCenterPreviewTable;
